import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const appTokenInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.url.includes(environment.apiUrl)) {
    request = request.clone({
      setParams: {
        appToken: environment.creatorAppToken,
      },
    });
  }
  return next(request);
};
